<template lang="pug">
.row
  .col-lg-6.col-12(v-if="menuData.length > 0")
    b-form-group(:label="$t('ui.menu')" label-class="font-weight-bold text-dark ml-1").mb-0
      .clusterize-scroll.table-responsive.mb-3
        table.table.table-sm.table-bordered.table-hover.table-align-middle
          thead.thead-light
            tr
              th(width="70%")
                div {{ $t("ui.menu") }}
              th(width="30%")
                div {{ $t("ui.show") }}
          tbody
            template(v-for="(item, index) in menuData")
              tr(:class="{ 'tree-active' : item.children.length > 0, 'tree-header-color' : item.position == 'HEADER' }")
                td
                  span {{ $t('ui.menulist.' + item.content_id) }}
                td.text-center()
                  span
                    i(:class="{'fas fa-check text-success': !item.is_hidden, 'fas fa-times text-danger': item.is_hidden }")
              tr(v-if="item.children")
                td.p-0(colspan=2)
                  .clusterize-scroll.table-responsive
                    table.table.table-sm.table-bordered.mb-0
                      tbody
                        template(v-for="(childitem, childindex) in item.children")
                          tr.menu-child
                            td(width="70%")
                              span.ml-2 {{ $t('ui.menulist.' + childitem.text) }}
                            td.text-center(width="30%")
                              span
                                i(:class="{'fas fa-check text-success': !childitem.is_hidden, 'fas fa-times text-danger': childitem.is_hidden }")

  .col-lg-6.col-12(v-if="gameMenuData.length > 0")
    b-form-group(:label="$t('ui.game_menu')" label-class="font-weight-bold text-dark ml-1").mb-0
      .clusterize-scroll.table-responsive.mb-3
        table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
          thead.thead-light
            tr
              th
                div {{ $t("ui.menu") }}
              th
                div {{ $t("ui.show") }}
          tbody
            tr(v-for="(item, index) in gameMenuData")
              td
                span {{ $t('ui.menulist.' + item.content_id) }}
              td.text-center
                span
                  i(:class="{'fas fa-check text-success': !item.is_hidden, 'fas fa-times text-danger': item.is_hidden }")

  .col-lg-6.col-12(v-if="specialMenuData.length > 0")
    b-form-group(:label="$t('ui.special_menu')" label-class="font-weight-bold text-dark ml-1").mb-0
      .clusterize-scroll.table-responsive.mb-3
        table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
          thead.thead-light
            tr
              th
                div {{ $t("ui.menu") }}
              th
                div {{ $t("ui.show") }}
          tbody
            tr(v-for="(item, index) in specialMenuData")
              td
                span {{ $t('ui.menulist.' + item.content_id) }}
              td.text-center
                span
                  i(:class="{'fas fa-check text-success': !item.is_hidden, 'fas fa-times text-danger': item.is_hidden }")

  .col-lg-6.col-12(v-if="settingMenuData.length > 0")
    b-form-group(:label="$t('ui.setting_menu')" label-class="font-weight-bold text-dark ml-1").mb-0
      .clusterize-scroll.table-responsive.mb-3
        table.table.table-sm.table-bordered.table-hover.table-align-middle
          thead.thead-light
            tr
              th(width="70%")
                div {{ $t("ui.menu") }}
              th(width="30%")
                div {{ $t("ui.show") }}
          tbody
            template(v-for="(item, index) in settingMenuData")
              tr(:class="{ 'tree-active' : item.children.length > 0, 'tree-header-color' : item.position == 'HEADER' }")
                td
                  span {{ $t('ui.menulist.' + item.content_id) }}
                td.text-center()
                  span
                    i(:class="{'fas fa-check text-success': !item.is_hidden, 'fas fa-times text-danger': item.is_hidden }")
              tr(v-if="item.children")
                td.p-0(colspan=2)
                  .clusterize-scroll.table-responsive
                    table.table.table-sm.table-bordered.mb-0
                      tbody
                        template(v-for="(childitem, childindex) in item.children")
                          tr.menu-child
                            td(width="70%")
                              span.ml-2 {{ $t('ui.menulist.' + childitem.text) }}
                            td.text-center(width="30%")
                              span
                                i(:class="{'fas fa-check text-success': !childitem.is_hidden, 'fas fa-times text-danger': childitem.is_hidden }")

</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import DisplayLayoutBox from '@/components/siteeditor/DisplayLayoutBox.vue'

export default {
  components: {
    DisplayLayoutBox
  },
  props: {
    siteId: {
      type: Number
    },
    siteDetails: {
      type: Array
    },
  },
  data: () => ({
    loading: false,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    menuData: [],
    gameMenuData: [],
    specialMenuData: [],
    settingMenuData: []
  }),
  computed: {
    accountType() {
      return this.$store.getters.accountType;
    },
    isAdmin() {
      return this.$store.getters.accountType === 5;
    },
    isAdminMaster() {
      return [3,5].includes(this.$store.getters.accountType);
    }
  },
  mounted: function() {
    this.assignAllMenu();
  },
  methods: {
    assignAllMenu() {
      var menuList = this.siteDetails
      var menu = [];
      var game = [];
      var special = [];
      var settingDropDown = [];

      for(var i = 0; i < menuList.length; i++) {
        var info = menuList[i]
        if(info.theme_content_group == 'menu') {
          menu.push(info)
        } else if(info.theme_content_group == 'game_menu') {
          game.push(info)
        } else if(info.theme_content_group == 'special') {
          special.push(info)
        } else if(info.theme_content_group == 'dropdown') {
          settingDropDown.push(info)
        }
      }

      this.setMenuData(menu);
      this.gameMenuData = game;
      this.specialMenuData = special
      this.setSettingMenuData(settingDropDown);
    },
    setMenuData(menuList) {
      var parentList = [];
      var childList = [];

      for(var i = 0; i < menuList.length; i++) {
        var json = {};
        var parentId = menuList[i].parent_content_id

        if(parentId == null) {

          json = {
            text: menuList[i].content_id,
            content_id: menuList[i].content_id,
            is_hidden: menuList[i].is_hidden,
            position: menuList[i].position,
            theme_content_group: menuList[i].theme_content_group,
            children: []
          }
          parentList.push(json)
        } else {
          json = {
            parent_content_id: menuList[i].parent_content_id,
            text: menuList[i].content_id,
            is_hidden: menuList[i].is_hidden,
            position: menuList[i].position,
            theme_content_group: menuList[i].theme_content_group
          }
          childList.push(json)
        }
      }

      for(var i = 0; i < parentList.length; i++) {
        var contentId = parentList[i].content_id
        for(var j = 0; j < childList.length; j++) {
          var parentId = childList[j].parent_content_id
          if(contentId == parentId) {
            parentList[i].children.push(childList[j])
          }
        }
      }

      this.menuData = parentList
    },
    setSettingMenuData(menuList) {
      var parentList = [];
      var childList = [];

      for(var i = 0; i < menuList.length; i++) {
        var json = {};
        var parentId = menuList[i].parent_content_id

        if(parentId == null) {

          json = {
            text: menuList[i].content_id,
            content_id: menuList[i].content_id,
            is_hidden: menuList[i].is_hidden,
            position: menuList[i].position,
            theme_content_group: menuList[i].theme_content_group,
            children: []
          }
          parentList.push(json)
        } else {
          json = {
            parent_content_id: menuList[i].parent_content_id,
            text: menuList[i].content_id,
            is_hidden: menuList[i].is_hidden,
            position: menuList[i].position,
            theme_content_group: menuList[i].theme_content_group
          }
          childList.push(json)
        }
      }

      for(var i = 0; i < parentList.length; i++) {
        var contentId = parentList[i].content_id
        for(var j = 0; j < childList.length; j++) {
          var parentId = childList[j].parent_content_id
          if(contentId == parentId) {
            parentList[i].children.push(childList[j])
          }
        }
      }

      this.settingMenuData = parentList
    }
  }
};
</script>